import React from 'react';
import { useFieldHelper } from 'framework/ui/field';
import { Box } from '@mui/material';
import { CountryBadge } from 'framework/form';

const CandidateCountry = () => {
  const { getValue } = useFieldHelper({ source: 'residenceCountry' });
  const countryCode = getValue();
  if (typeof countryCode === 'undefined') {
    return '';
  }
  return (
    <Box sx={{ padding: '0px', width: '25px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <CountryBadge country={countryCode} />
    </Box>
  );
};

export default CandidateCountry;
